export default "__VITE_ASSET__BoARzHkm__"